let activeTooltip = null

function removeTooltip() {
  if (activeTooltip && activeTooltip.parentNode) activeTooltip.parentNode.removeChild(activeTooltip)
  activeTooltip = null
}

export function bindSidebarTooltips(vm) {
  const cleanups = []

  const bind = () => {
    cleanups.splice(0).forEach(cleanup => cleanup())
    vm.$el.querySelectorAll('.c-sidebar-nav-link').forEach(link => {
      const show = () => {
        if (!vm.$store.state.sidebarMinimize) return
        removeTooltip()
        const label = link.getAttribute('data-sidebar-label') || link.textContent.trim()
        if (!label) return
        const rect = link.getBoundingClientRect()
        const sidebarRect = vm.$el.getBoundingClientRect()
        const tooltip = document.createElement('div')
        tooltip.className = 'role-sidebar-tooltip'
        tooltip.textContent = label
        tooltip.style.left = `${Math.round(sidebarRect.right + 7)}px`
        tooltip.style.top = `${Math.round(rect.top + rect.height / 2)}px`
        document.body.appendChild(tooltip)
        activeTooltip = tooltip
      }
      link.addEventListener('mouseenter', show)
      link.addEventListener('focus', show)
      link.addEventListener('mouseleave', removeTooltip)
      link.addEventListener('blur', removeTooltip)
      cleanups.push(() => {
        link.removeEventListener('mouseenter', show)
        link.removeEventListener('focus', show)
        link.removeEventListener('mouseleave', removeTooltip)
        link.removeEventListener('blur', removeTooltip)
      })
    })
  }

  vm.$nextTick(bind)
  vm._refreshSidebarTooltips = bind
  vm._destroySidebarTooltips = () => {
    cleanups.splice(0).forEach(cleanup => cleanup())
    removeTooltip()
  }
}

export function refreshSidebarTooltips(vm, labels) {
  vm.$nextTick(() => {
    vm.$el.querySelectorAll('.c-sidebar-nav-link').forEach((link, index) => {
      link.setAttribute('data-sidebar-label', labels[index] || '')
    })
    if (vm._refreshSidebarTooltips) vm._refreshSidebarTooltips()
  })
}

export function unbindSidebarTooltips(vm) {
  if (vm._destroySidebarTooltips) vm._destroySidebarTooltips()
}
